<template>
    <div v-html="textHtml" :class="labelClasses" :style="labelStyles">
    </div>
</template>

<script>
    export default {
        name: 'TextRenderer',
        props: ['component', 'textValue', 'containerWidth', 'layout'],
        data() {
            return {
                model: webase.model
            }
        },
        computed: {
            textHtml() {
                return this.textValue ? this.textValue : this.component.value
            },
            labelClasses() {
                if(this.component && this.component.style && this.component.style.nowrap) {
                    return `${this.colorClass} ${this.sizeClass} truncated-text`.trim()
                }

                return `${this.colorClass} ${this.sizeClass}`.trim()
            },

            labelStyles() {
                let styles = `${this.colorStyle}`

                // if (this.containerWidth && this.containerWidth > 0) {
                //     styles += ` width: ${this.containerWidth}px;`
                // }

                return styles
            },

            colorStyle() {
                if (this.isCustomColor) {
                    return `color: ${this.component.style.color};`
                }

                return ''
            },

            sizeClass() {
                if (!this.component.style.size) {
                    return ''
                }

                return `${this.component.style.size}`
            },

            colorClass() {
                if(this.layout.theme_id) {
                    return ''
                }

                if (this.component.style && this.component.style.color && this.component.style.color !== 'custom' && this.component.style.color.indexOf('#') !== 0) {
                    return `text-${this.component.style.color}`
                }

                return ''
            },

            isCustomColor() {
                return webase.utils.ui.isCustomColor(this.component)
            }
        },
        mounted() {
        },
        methods: {
            importantMethodHere() {
            }
        }
    }
</script>
